import * as React from "react";
import { useState, useEffect} from "react";
import { ResponsiveBar } from '@nivo/bar';
import * as moment from "moment";
import Modal from "../core/Modal";
const user_icon = "https://chartec-core-public.s3-us-west-1.amazonaws.com/user.png";

interface IProps {
  userContext?:any;
  hasMarketing?:any;
  v2Token?:any;
}

async function get_project(rec_id, v2_token, setProject, setInfo, setOpenProject){
    let html = [];
    let resp = await fetch(`https://api.chartec.net/v2/marketing/${rec_id}`, {
    method: 'GET', 
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': v2_token
    }
  })
  let json = await resp.json();
  json.forEach(project => {
      project.longname = `${project.name} (${project.project_complete_percent_by_ticket}% Complete)`;
      let createdMoment = moment(project.start_date);
      html.push(<tr><td>{project.name}<br/><small><i className="fa fa-clock-o"></i> Started {createdMoment.format('MMMM Do YYYY')}</small></td><td><strong>{project.project_complete_percent_by_ticket}%</strong></td><td><span className="label label-pill label-success" onClick={()=>{setInfo(true), setOpenProject(project)}} style={{cursor: "pointer"}}>More Information</span></td></tr>);
  })
  setProject(html);
}

async function get_high_scores(rec_id, v2_token, setHighContacts, setTotalContacts){
    let html = [];
    let resp = await fetch(`https://api.chartec.net/v2/ac/contactscores/${rec_id}`, {
    method: 'GET', 
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': v2_token
    }
  })
  let json = await resp.json();
  json.forEach(contact => {
      html.push(<tr><td>{contact.firstName} {contact.lastName}</td><td>{contact.phone}</td><td>{contact.email}</td><td>{contact.orginization}</td><td><span className="label label-pill label-success">{contact.scoreTotal}</span></td></tr>);
      contact.hasOwnProperty("total") ? setTotalContacts(contact.total) : "";
  })
  setHighContacts(html);
}

async function get_inital_data(rec_id, v2_token, setTotalOpensCurrent, setCampaignsGraph,setTotalClicksCurrent,setTotalBouncesCurrent,setTotalCampaignsSent, setTotalOpensPrevious, setTotalBouncesPrevious, setTotalCampaignsSentPrevious, setTotalClicksPrevious, setLatestCampaign){
  var date = new Date();
  var currentMonth = date.getMonth();
  var previousMonth = date.getMonth()-1;
  var currentYear = date.getFullYear();
  var currentDay = date.getDate();
  let resp = await fetch(`https://api.chartec.net/v2/ac/campaigns/${rec_id}`, {
    method: 'GET', 
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': v2_token
    }
  })
  let json = await resp.json();
  let totalopens = 0;
  let totalclicks = 0;
  let totalbounces = 0;
  let totalcampaigns = 0;
  let totalpreviousopens = 0;
  let totalpreviousclicks = 0;
  let totalpreviousbounces = 0;
  let totalpreviouscampaigns = 0;
  let campaign_objects = [];

  json.campaigns.forEach(campaign => {
    let campaignSendDate = new Date(campaign.sdate);
    let monthYear = campaignSendDate.toLocaleString('default', { month: 'short', year: 'numeric' });
    let exists = false;
    let uindex;
    campaign_objects.forEach((unique,index) => {
        if(unique.id == monthYear){
            exists = true;
            uindex = index;
        }
    });
    if(!exists){
        campaign_objects.push({"id":monthYear, "sends":Number(campaign.send_amt), "opens":Number(campaign.opens), 'clicks':Number(campaign.linkclicks), 'softbounces':Number(campaign.softbounces), 'campaigns':1});
    } else {
        if(campaign_objects[uindex].id == monthYear){
            campaign_objects[uindex].sends += Number(campaign.send_amt);
            campaign_objects[uindex].opens += Number(campaign.opens);
            campaign_objects[uindex].clicks += Number(campaign.linkclicks);
            campaign_objects[uindex].softbounces += Number(campaign.softbounces);
            campaign_objects[uindex].campaigns += 1;
        } else {
            //console.log('index doesnt match');
        }
    }
    if(campaignSendDate.getMonth() == currentMonth && campaignSendDate.getFullYear() == currentYear){
      totalopens += Number(campaign.opens);
      totalclicks += Number(campaign.linkclicks);
      totalbounces += Number(campaign.softbounces);
      totalcampaigns += 1;
    } else if(campaignSendDate.getMonth() == previousMonth && campaignSendDate.getFullYear() == currentYear && campaignSendDate.getDay() <= currentDay){
      totalpreviousopens += Number(campaign.opens);
      totalpreviousclicks += Number(campaign.linkclicks);
      totalpreviousbounces += Number(campaign.softbounces);
      totalpreviouscampaigns += 1;
    }
  });
  let opensdiff = ((totalopens - totalpreviousopens) / totalpreviousopens * 100).toLocaleString('fullwide', {maximumFractionDigits:2});
  let opendiffdisplay = (Math.sign(Number(opensdiff)) == 1 ? <small className='success'>{opensdiff}% <i className="fa fa-level-up text-success"/></small> : Math.sign(Number(opensdiff)) == -1 ? <small className="danger">{opensdiff}% <i className="fa fa-level-down"/></small> : '');
  let clicksdiff = ((totalclicks - totalpreviousclicks) / totalpreviousclicks * 100).toLocaleString('fullwide', {maximumFractionDigits:2});
  let clicksdiffdisplay = (Math.sign(Number(clicksdiff)) == 1 ? <small className='success'>{clicksdiff}% <i className="fa fa-level-up text-success"/></small> : Math.sign(Number(clicksdiff)) == -1 ? <small className="danger">{clicksdiff}% <i className="fa fa-level-down"/></small> : '');
  let bouncesdiff = ((totalbounces - totalpreviousbounces) / totalpreviousbounces * 100).toLocaleString('fullwide', {maximumFractionDigits:2});
  let bouncesdiffdisplay = (Math.sign(Number(bouncesdiff)) == -1 ? <small className='success'>{bouncesdiff}% <i className="fa fa-level-up text-success"/></small> : Math.sign(Number(bouncesdiff)) == 1 ? <small className="danger">{bouncesdiff}% <i className="fa fa-level-down"/></small> : '');
  let campaignsdiff = ((totalcampaigns - totalpreviouscampaigns) / totalpreviouscampaigns * 100).toLocaleString('fullwide', {maximumFractionDigits:2});
  let campaignsdiffdisplay = (Math.sign(Number(campaignsdiff)) == 1 ? <small className='success'>{campaignsdiff}% <i className="fa fa-level-up text-success"/></small> : Math.sign(Number(campaignsdiff)) == -1 ? <small className="danger">{campaignsdiff}% <i className="fa fa-level-down"/></small> : '');
  
  setTotalOpensCurrent(<div className="hpanel stats"><div className="panel-body h-200"><div className="stats-title pull-left"><h4>Opens</h4></div><div className="stats-icon pull-right"><i className="pe-7s-monitor fa-4x"></i></div><div className="m-t-xl"><h1 className="text-success">{totalopens}</h1>{opendiffdisplay}</div><span className="font-bold no-margins">Opens</span><br/><small>Amount of opens this month.</small></div><div className="panel-footer">Opens are {opendiffdisplay} vs last month at this time</div></div>);
  //console.log(json.campaigns);
//   console.log("opens:", totalopens, "clicks:", totalclicks, "bounces:", totalbounces, "campaigns:", totalcampaigns);
//   console.log("opens:", totalpreviousopens, "clicks:", totalpreviousclicks, "bounces:", totalpreviousbounces, "campaigns:", totalpreviouscampaigns);
  // console.log(((totalopens - totalpreviousopens) / totalpreviousopens * 100).toLocaleString('fullwide', {maximumFractionDigits:2}) + "%");
  //console.log(campaign_objects);
  setCampaignsGraph(campaign_objects.reverse());
  setTotalClicksCurrent(<div className="hpanel stats"><div className="panel-body h-200"><div className="stats-title pull-left"><h4>Clicks</h4></div><div className="stats-icon pull-right"><i className="pe-7s-monitor fa-4x"></i></div><div className="m-t-xl"><h1 className="text-success">{totalclicks}</h1>{clicksdiffdisplay}</div><span className="font-bold no-margins">Clicks</span><br/><small>Amount of clicks this month.</small></div><div className="panel-footer">Clicks are {clicksdiffdisplay} vs last month at this time</div></div>);
  setTotalBouncesCurrent(<div className="hpanel stats"><div className="panel-body h-200"><div className="stats-title pull-left"><h4>Bounces</h4></div><div className="stats-icon pull-right"><i className="pe-7s-monitor fa-4x"></i></div><div className="m-t-xl"><h1 className="text-success">{totalbounces}</h1>{bouncesdiffdisplay}</div><span className="font-bold no-margins">Bounces</span><br/><small>Amount of soft bounces this month.</small></div><div className="panel-footer">Soft Bounces are {bouncesdiffdisplay} vs last month at this time</div></div>);
  setTotalCampaignsSent(<div className="hpanel stats"><div className="panel-body h-200"><div className="stats-title pull-left"><h4>Campaigns Sent</h4></div><div className="stats-icon pull-right"><i className="pe-7s-monitor fa-4x"></i></div><div className="m-t-xl"><h1 className="text-success">{totalcampaigns}</h1>{campaignsdiffdisplay}</div><span className="font-bold no-margins">Campaigns</span><br/><small>Amount of campaigns sent this month.</small></div><div className="panel-footer">Campaigns are {campaignsdiffdisplay} vs last month at this time</div></div>);
  setTotalOpensPrevious(totalpreviousopens);
  setTotalClicksPrevious(totalpreviousclicks);
  setTotalBouncesPrevious(totalpreviousbounces);
  setTotalCampaignsSentPrevious(totalpreviouscampaigns);
  setLatestCampaign(json.campaigns[0]);
}

function MarketingDashboard(props:IProps){
  let this_month = new Date();
  const [totalOpensCurrent, setTotalOpensCurrent] = useState('loading');
  const [totalClicksCurrent, setTotalClicksCurrent] = useState('loading');
  const [totalBouncesCurrent, setTotalBouncesCurrent] = useState('loading');
  const [totalCampaignsSent, setTotalCampaignsSent] = useState('loading');
  const [totalOpensPrevious, setTotalOpensPrevious] = useState('loading');
  const [totalClicksPrevious, setTotalClicksPrevious] = useState('loading');
  const [totalBouncesPrevious, setTotalBouncesPrevious] = useState('loading');
  const [totalCampaignsSentPrevious, setTotalCampaignsSentPrevious] = useState('loading');
  const [latestCampaign, setLatestCampaign] = useState({name:'', linkclicks:'', opens:''});
  const [campaignsGraph, setcampaignsGraph] = useState([{"id":"loading", "color":"hsl(101, 70%, 40%)", "data":[{"x":"loading", "y":0}, {"x":"loading...", "y":0}]}]);
  const [highContacts, setHighContacts] = useState('loading');
  const [totalContacts, setTotalContacts] = useState('loading');
  const [project, setProject] = useState('loading');
  const [info, setInfo] = useState(false);
  const [openProject, setOpenProject] = useState({"name":"loading", "phases":[], "members":[], "longname":"loading"});
  useEffect(() => {
    get_inital_data(props.userContext.organization.data.attributes.connectWise.cwRecid, props.v2Token, setTotalOpensCurrent, setcampaignsGraph, setTotalClicksCurrent, setTotalBouncesCurrent, setTotalCampaignsSent, setTotalOpensPrevious, setTotalBouncesPrevious, setTotalCampaignsSentPrevious, setTotalClicksPrevious, setLatestCampaign);
    get_high_scores(props.userContext.organization.data.attributes.connectWise.cwRecid, props.v2Token, setHighContacts, setTotalContacts);
    get_project(props.userContext.organization.data.attributes.connectWise.cwRecid, props.v2Token, setProject, setInfo, setOpenProject);
}, [])

  return(
    <div>
        <div className="row">
            <div className="col-lg-3">
                <div className="hpanel stats">
                    <div className="panel-body">
                        {(totalContacts == 'loading' ? <span className="loading"><i className="loading fa fa-cog fa-spin fa-2x"></i></span> :
                            <span><div className="stats-title pull-left"><h4>Total Contacts</h4></div>
                            <div className="m-t-xl"><h3 className="text-success">{totalContacts}</h3></div></span>
                        )}
                    </div>
                </div>
            </div>
            <div className="col-lg-12">
                <div className="hpanel">
                    <div className="panel-heading">
                        Marketing information and statistics
                    </div>
                    <div className="panel-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="text-center small">
                                    <i className="fa fa-laptop"></i> Campaign Stats over time
                                </div>
                                <div className="flot-chart" style={{height: "300px"}}>
                                {(campaignsGraph[0].id == 'loading' ? <span className="loading"><i className="loading fa fa-cog fa-spin fa-2x"></i></span> :
                                <ResponsiveBar
                                  data={campaignsGraph}
                                  keys={[ 'sends', 'opens', 'clicks', 'softbounces']}
                                  indexBy="id"
                                  margin={{ top: 50, right: 100, bottom: 40, left: 60 }}
                                  padding={0.3}
                                  groupMode="grouped"
                                  valueScale={{ type: 'linear' }}
                                  indexScale={{ type: 'band', round: true }}
                                  colors={{ scheme: 'accent' }}
                                  borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                                  axisTop={null}
                                  axisRight={null}
                                  axisBottom={{
                                      tickSize: 5,
                                      tickPadding: 5,
                                      tickRotation: 0,
                                      legend: 'month',
                                      legendPosition: 'middle',
                                      legendOffset: 32
                                  }}
                                  labelSkipWidth={12}
                                  labelSkipHeight={12}
                                  labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                                  legends={[
                                      {
                                          dataFrom: 'keys',
                                          anchor: 'bottom-right',
                                          direction: 'column',
                                          justify: false,
                                          translateX: 120,
                                          translateY: 0,
                                          itemsSpacing: 2,
                                          itemWidth: 100,
                                          itemHeight: 20,
                                          itemDirection: 'left-to-right',
                                          itemOpacity: 0.85,
                                          symbolSize: 20,
                                          effects: [
                                              {
                                                  on: 'hover',
                                                  style: {
                                                      itemOpacity: 1
                                                  }
                                              }
                                          ]
                                      }
                                  ]}
                                  animate={true}
                                  motionStiffness={90}
                                  motionDamping={15}
                              />
                              )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="panel-footer">
                    <span className="pull-right">
                    </span>
                        Last update: {this_month.toLocaleString()}
                    </div>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-3">
              {(totalClicksCurrent == 'loading' ? <span className="loading"><i className="loading fa fa-cog fa-spin fa-2x"></i></span> :
              totalClicksCurrent)}
            </div>
            <div className="col-lg-3">
            {(totalBouncesCurrent == 'loading' ? <span className="loading"><i className="loading fa fa-cog fa-spin fa-2x"></i></span> :
              totalBouncesCurrent)}
            </div>
            <div className="col-lg-3">
            {(totalCampaignsSent == 'loading' ? <span className="loading"><i className="loading fa fa-cog fa-spin fa-2x"></i></span> :
              totalCampaignsSent)}
            </div>
            <div className="col-lg-3">
            {(totalOpensCurrent == 'loading' ? <span className="loading"><i className="loading fa fa-cog fa-spin fa-2x"></i></span> :
              totalOpensCurrent)}
            </div>
        </div>
        <div className="row">
            <div className="col-lg-6">
                <div className="hpanel">
                    <div className="panel-heading">
                        Highest Scoring Contacts
                    </div>
                    <div className="panel-body list">
                        <div className="table-responsive project-list">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Phone</th>
                                        <th>Email</th>
                                        <th>Score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {(highContacts == 'loading' ? <span className="loading"><i className="loading fa fa-cog fa-spin fa-2x"></i></span> :
                                highContacts)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-6">
                <div className="hpanel">
                    <div className="panel-heading">
                        Active Projects
                    </div>
                    <div className="panel-body list">
                        {(project.length ?
                            <div className="table-responsive project-list">
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <th>Project</th>
                                        <th>Progress</th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {project}
                                    </tbody>
                                </table>
                            </div>
                        : 'No Projects Available')}
                    </div>
                </div>
            </div>
        </div>
        <Modal
              title={openProject.longname} 
              open={info}
              isLarge={true}
              submittable={false}
              closeText="Close"
              disallowClickOutside={true}
              close={() => {setInfo(false)}}
            >
                <h6><strong>Project Members</strong></h6>
                {openProject.members.map((member,i) => {
                    return(<div key={i} className="chip">
                    <img src={user_icon} alt="Person" width="96" height="96"/>
                    {member.name}
                  </div>);
                })}
                <br/>
                <h6><strong>Project Phases</strong></h6>
                {openProject.phases.map((phase,i) => {
                    let html_phase_tickets = [];
                    if(phase.tickets != null){
                        phase.tickets.forEach(ticket => {
                            let ti;
                            switch(ticket.status) {
                                case 'New':
                                ti = <span className="badge">New</span>;
                                break;
                                case 'Closed':
                                ti = <span className="badge" style={{backgroundColor:'#59ce67'}}>Completed</span>;
                                break;
                                case 'In Progress':
                                ti = <span className="badge">In Progress</span>;
                                break;
                                default:
                                ti = <span className="badge">New</span>;
                            }
                            if(phase.ongoing_phase){
                                html_phase_tickets.push(<li className="list-group-item">{ticket.name} - {ti}</li>);
                            } else {
                                html_phase_tickets.push(<li className="list-group-item">{ticket.name} - {ti}</li>);
                            }
                        });
                    }
                    if(phase.ongoing_phase){
                        return(
                            <div key={i} className="panel panel-default">
                                <div className="panel-heading">
                                    On Going - {phase.name} - {phase.phase_complete_percent}%
                                </div>
                                <div className="panel-body">
                                    <ul className="list-group list-group-flush">{html_phase_tickets}</ul>
                                </div>
                            </div>
                        )
                    } else {
                        return(
                            <div key={i} className="panel panel-default">
                                <div className="panel-heading">
                                    {phase.name} - {phase.phase_complete_percent}%
                                </div>
                                <div className="panel-body">
                                    <ul className="list-group list-group-flush">{html_phase_tickets}</ul>
                                </div>
                            </div>
                        )
                    }
                })}
            </Modal>
    </div>
  )
}

export default MarketingDashboard


// WEBPACK FOOTER //
// ./app/javascript/components/pages/MarketingDashboard.tsx